import { Component, OnInit } from '@angular/core';

class model{
}

@Component({
	templateUrl: './maths.component.html',
	styleUrls: ['./maths.component.css']
})

export class MathsComponent implements OnInit {
	public m: model;
	ngOnInit() {
		this.m = new model();
	}
}


// WEBPACK FOOTER //
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/academics/maths.component.ts